export const isProdSite = (branchName: string) => branchName === 'master'
